
import ACTS from '../constants'

const defaultStatus = {
    title: '경영실적'
}

export default (state = defaultStatus, action) => {
    switch(action.type) {
        case ACTS.PERFOR_SUMMARY:        
        return{
            ...state,
            items : action.payload.item
        }
        default:        
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/report.js